import { useStore } from '@cobuildlab/react-simple-state';
import { PlanDetailsTabs } from './plan-types';
import { plansSteps } from './plan-store';

interface DetailsPlanStepsReturn {
  step: PlanDetailsTabs;
  handleChangeStep: (newStep: PlanDetailsTabs) => void;
}

export const useDetailsPlanSteps = (): DetailsPlanStepsReturn => {
  const step = useStore(plansSteps);
  const handleChangeStep = (newStep: PlanDetailsTabs): void => {
    plansSteps.dispatch(newStep);
  };

  return {
    step,
    handleChangeStep,
  };
};
